import * as Actions from "./constants";

/**
 * Action login
 */
export function SignIn({ postData }) {
  return {
    type: Actions.LOGIN,
    postData,
  };
}

/**
 * Action sign out
 */
export function SignOut() {
  return {
    type: Actions.LOGOUT,
  };
}

/**
 * Action set current user
 */
export const setCurrentUser = (decoded) => {
  return {
    type: Actions.SET_CURRENT_USER,
    payload: decoded,
  };
};
